import type { CSSProperties } from 'react';

/**
 * 对外品牌常量。
 *
 * 这里的名字与 `useSiteConfig().siteName`（后台 `system_info.siteName`）不是同一个事实，
 * 不要互相替换：站点名必须与 ICP 备案的网站名称一致（当前为「活动精英订单预约管理系统」），
 * 而「活动精英助手」是 App / 产品名——网站与 App 各备各的号，名称本就可以不同。
 * 需要打品牌标识的对外出口（分享页等）用这两个常量。
 */
export const BRAND_NAME = '活动精英助手';

/** 品牌口号：与 about / contact / terms 等页脚用的是同一句话 */
export const BRAND_SLOGAN = '让每一笔业务都有据可查';

/**
 * 品牌强调色，逐字取自 Flutter `AppColors.light.primary`（`core/theme/app_theme.dart`）。
 *
 * 对外页（分享页）刻意用它、而不是站点主题色：`--color-primary-*` 那套是**登录用户自己挑的**
 * 界面外观，走 `[data-theme]` 切换，而分享页的访客没有主题——他打开就该看到产品本来的颜色。
 * Tailwind 里那个静态的 `primary` 调色板是蓝色，与品牌无关，不要拿它当品牌色用。
 *
 * 这一档只用于**不承载文字的图形**（分组短标）。白字压在它上面只有 3.3:1，低于正文 4.5:1 的底线，
 * 所以按钮、色带这类要放白字的地方一律用下面两档，不要图省事直接用它。
 */
export const BRAND_ACCENT = '#D96C2E';
/** 同色相压暗一档：白字 4.8:1，是「可以放正文」的最浅橙 */
export const BRAND_ACCENT_STRONG = '#B85520';
/** 再压一档：白字 7.2:1，色带深端与按下态 */
export const BRAND_ACCENT_DEEP = '#8F4113';
/**
 * 页面底色：带一点暖的白。
 *
 * 原来是 `gray-50`（纯中性灰）。灰底配橙字是两套不相干的色温，品牌区会显得浮在上面——
 * 用户反馈的「光秃秃、不协调」根因在这里，而不是缺装饰。
 */
export const BRAND_PAGE_BG = '#FAF7F5';

/**
 * 挂到页面根节点上，子树用 `bg-[var(--brand)]` / `text-[var(--brand-strong)]` 取用。
 *
 * `--brand-*` 是自定义属性，csstype 的 `CSSProperties` 不收它，直接传会报 TS2559，
 * 所以在这一个出口处转交类型，消费方照旧写 `style={BRAND_CSS_VARS}`。
 */
export const BRAND_CSS_VARS = {
  '--brand': BRAND_ACCENT,
  '--brand-strong': BRAND_ACCENT_STRONG,
  '--brand-deep': BRAND_ACCENT_DEEP,
  '--brand-page': BRAND_PAGE_BG,
} as CSSProperties;
